import { MarkdownRenderer } from './renderer';
import { lxkShowStreamStatus } from './StatusComponent';

export class PreviewComponent {
    constructor() {
        this.currentPreview = null; 
        this.statusMessages = [];
        this.markdownRenderer = new MarkdownRenderer();
    }

    getEmptyState() {
        return `
            <div class="lxk-flex lxk-flex-col lxk-items-center lxk-justify-center lxk-h-full lxk-gap-4">
                <div class="lxk-text-lexeek-content-alt lxk-text-center">
                    <p class="lxk-text-lg lxk-font-medium">Search or ask questions about Engagespot</p>
                    <p class="lxk-text-sm">Click on search results to preview or use Ask Lex to get AI-powered answers</p>
                </div>
            </div>
        `;
    }

    async showSourcePreview(source) {
        if (!source) return this.getEmptyState();

        const previewContent = document.createElement('div');
        previewContent.className = 'lxk-flex lxk-flex-col lxk-h-full';
        
        if (source.redirect_url) {
            const linkDiv = document.createElement('div');
            linkDiv.innerHTML = `
                <a href="${source.redirect_url}" target="_blank" 
                    class="lxk-flex lxk-items-center lxk-gap-2 lxk-mb-4 lxk-text-lexeek-accent hover:lxk-underline">
                    <span>Go to page</span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="lxk-w-4 lxk-h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                    </svg>
                </a>
            `;
            previewContent.appendChild(linkDiv);
        }

        const contentDiv = document.createElement('div');
        contentDiv.className = 'lxk-flex-1 lxk-overflow-y-auto lxk-markdown-content';
        await this.markdownRenderer.render(source.content || '', contentDiv);
        previewContent.appendChild(contentDiv);

        return previewContent.outerHTML;
    }

    async handleStreamData(data, modalContent) {
        try {
            // Handle status updates with status array
            if (data.status && data.answer === null) {
                this.statusMessages.push(data.status.status_message);
                const currentStep = 
                    data.status.status === "analyzing_query" ? 0 :
                    data.status.status === "searching" ? 1 :
                    data.status.status === "processing" ? 2 :
                    data.status.status === "formulating" ? 3 : 0;
                
                modalContent.innerHTML = lxkShowStreamStatus(
                    this.statusMessages, 
                    currentStep
                );
                return null;
            }
    
            // Handle streaming answer
            if (data.answer !== null) {
                const contentWrapper = document.createElement('div');
                contentWrapper.className = 'lxk-markdown-content';
                
                // Store the event listeners
                const eventListeners = await this.markdownRenderer.render(
                    data.answer,
                    contentWrapper
                );
                
                modalContent.innerHTML = contentWrapper.innerHTML;
                
                // Reattach event listeners
                eventListeners.forEach(listener => {
                    const { element, type, handler } = listener;
                    const selector = `.${element.className.split(' ')[0]}`;
                    const elements = modalContent.querySelectorAll(selector);
                    elements.forEach(el => {
                        el.addEventListener(type, handler);
                    });
                });
                
                return eventListeners;
            }
        } catch (error) {
            console.error('Stream handling error:', error);
            return null;
        }
    }

    resetStream() {
        this.statusMessages = [];
        this.currentPreview = null;
    }

    async render(container, state) {
        try {
            const content = state.streamStatus ? this.showStreamStatus(state.streamStatus)
                            : state.currentPreview ? await this.showSourcePreview(state.currentPreview)
                            : this.getEmptyState();

            if (container && content) {
                container.innerHTML = content;
            }
            return content;
        } catch (error) {
            console.error('Preview render error:', error);
            return this.getEmptyState();
        }
    }

    cleanup() {
        if (this.currentEventListeners) {
            this.currentEventListeners.forEach(listener => {
                const { element, type, handler } = listener;
                if (element && element.removeEventListener) {
                    element.removeEventListener(type, handler);
                }
            });
        }
        this.resetStream();
    }
}